import React, { useState, useRef, useEffect } from "react";
import { useSubscribe } from '../../hooks';
import { error$ } from '../../observables/error';
import { FailureType } from '../../shared/types';
import { Modal, ModalButtonID, Password, Checkbox } from '../../ui/components';
import styles from './Password.less';
export default function AskForPassword() {
    const [connectionId, setConnectionId] = useState();
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(true);
    const input = useRef(null);
    useSubscribe(() => error$.subscribe(error => {
        if (error.type == FailureType.Unauthorized && sessionStorage.getItem('Connecting')) {
            sessionStorage.removeItem('Connecting');
            setConnectionId(error.id);
        }
    }));
    useEffect(() => {
        connectionId && input.current?.focus();
    }, [connectionId]);
    // useEffect(() => {        // TODO: fix auto-login in FireFox
    //     if (!connectionId) {
    //         return
    //     }
    //     setTimeout(() => {
    //         const filledPassword = document.querySelector('input[name="password"]:autofill')
    //         const pass = (filledPassword as HTMLInputElement)?.value
    //         pass ?
    //             onClose(ModalButtonID.Ok, pass, false) :
    //             setShow(true)
    //     }, 600)
    // }, [connectionId])
    const buttons = [
        {
            id: ModalButtonID.Cancel,
            label: 'Cancel'
        },
        {
            id: ModalButtonID.Ok,
            label: 'Ok',
            disabled: !password.length
        }
    ];
    const onClose = (id, pass, rem) => {
        window.f5.login(connectionId, id == ModalButtonID.Ok ? (pass ?? password) : false, rem ?? remember);
        if (id != ModalButtonID.Ok) {
            const u = new URL(window.location.toString());
            u.searchParams.delete('connect');
            history.replaceState(null, '', u.toString());
        }
        setConnectionId(undefined);
    };
    return React.createElement(React.Fragment, null, connectionId &&
        React.createElement(Modal, { buttons: buttons, onClose: onClose },
            React.createElement("form", { className: styles.form, autoComplete: "on" },
                React.createElement("p", null,
                    "Connecting ",
                    React.createElement("em", null, connectionId),
                    "..."),
                React.createElement("div", { className: "username" },
                    React.createElement("input", { type: 'text', name: "username", value: connectionId, autoComplete: "username", readOnly: true })),
                React.createElement("p", null,
                    "Password: ",
                    React.createElement(Password, { ref: input, onChange: setPassword, name: 'password', autoComplete: 'current-password' })),
                React.createElement("p", null,
                    React.createElement(Checkbox, { onChange: remember => setRemember(remember), value: remember }, "Remember password for this session")))));
}
